export function applyRuntimeDocumentIdentity(
  productName = 'Hub360',
  documentRef = document
) {
  documentRef.title = productName || 'Hub360';
}
